/* eslint-disable @next/next/no-img-element */
import { useScreen } from '@/hooks/useScreen';
import { Button } from '@mui/material';
import { DetailedHTMLProps, ImgHTMLAttributes } from 'react';
import { FilledCameraIcon } from '../elements/svgIcon/filled';

interface IAvatar {
  canEdit: boolean;
  handleClickEdit: () => void;
  positionClass: string;
  imgProps: DetailedHTMLProps<
    ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >;
  editIconPosition?: string;
}

const Avatar: React.FunctionComponent<IAvatar> = ({
  canEdit,
  positionClass,
  handleClickEdit,
  imgProps,
  editIconPosition = 'bottom-0 right-0',
}) => {
  const { isDesktop } = useScreen();

  return (
    <>
      <div className={`absolute z-[9] ${positionClass}`}>
        <div className="relative">
          <img {...imgProps} alt="avatar" rel="preload" loading="lazy" />
          {canEdit && (
            <Button
              className={`!absolute ${editIconPosition}`}
              variant={
                !isDesktop ? 'rounded_medium_emphasis_v2' : 'medium_emphasis_v2'
              }
              sx={{
                minWidth: 0,
                padding: '9px',
              }}
              onClick={handleClickEdit}
            >
              <FilledCameraIcon
                width={isDesktop ? 20 : 16}
                height={isDesktop ? 20 : 16}
              />
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default Avatar;
